import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hidden"]

  connect() {
    document.addEventListener("customer:created", this.handleCustomerCreated.bind(this))
  }

  disconnect() {
    document.removeEventListener("customer:created", this.handleCustomerCreated.bind(this))
  }

  openModal(event) {
    event.preventDefault()
    const modalController = this.application.getControllerForElementAndIdentifier(
      document.getElementById("customerModal"),
      "modal"
    )
    modalController.open()
  }

  handleCustomerCreated(event) {
    if (!event.detail?.customer) return

    const { customer } = event.detail
    // Find the combobox controller
    const comboboxController = this.application.getControllerForElementAndIdentifier(
      this.element.querySelector("[data-controller='hw-combobox']"),
      "hw-combobox"
    )

    if (comboboxController) {
      // Update the hidden field value
      comboboxController.hiddenTarget.value = customer.id
      // Update the input field with the customer name
      comboboxController.inputTarget.value = customer.full_name
      // Close the combobox dropdown
      comboboxController.close()
    }
  }
}
